import { createFileRoute } from '@tanstack/react-router';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { AppearanceSettings } from '@/containers/appearance';
import { SettingsLayout } from '@/containers/settings/settings-layout.component';
import {
  SETTINGS_PANE_SECTION,
  SETTINGS_PANE,
} from '@/containers/settings/settings-pane';
import { SettingsPaneHeader } from '@/containers/settings/settings-pane-layout.component';

export const Route = createFileRoute('/settings/appearance')({
  component: AppearanceRoute,
});

function AppearanceRoute() {
  return (
    <AuthCheck>
      <Head heading='Appearance' />
      <SettingsLayout>
        <div className={SETTINGS_PANE}>
          <SettingsPaneHeader title='Appearance' hideTitle />
          <div
            className={`${SETTINGS_PANE_SECTION} first-of-type:border-t-0 first-of-type:pt-0`}
          >
            <AppearanceSettings />
          </div>
        </div>
      </SettingsLayout>
    </AuthCheck>
  );
}
